import { createSlice } from '@reduxjs/toolkit';

import {
  BuyerDashboardSelectedId
} from '../../interfaces/BuyerDashboardModel';
import { RootState } from '../../store';

// TODO: will have a separate CR to simplify the store
export interface SearchRFXRequestState {
  userVendorIds: string[];
  isModalVisible: boolean;
  requestIds: BuyerDashboardSelectedId[];
}

const initialState: SearchRFXRequestState = {
  userVendorIds: [],
  isModalVisible: false,
  requestIds: []
}

const searchRFXRequestSlice = createSlice({
  name: 'searchRFXRequest',
  initialState,
  reducers: {
    setUserVendorIds(state, action) {
      state.userVendorIds = action.payload;
    },
    setIsModalVisible(state, action) {
      state.isModalVisible = action.payload;
    },
    setRequestIds(state, action) {
      state.requestIds = action.payload;
    }
  }
});

export const {
  setUserVendorIds,
  setIsModalVisible,
  setRequestIds
} = searchRFXRequestSlice.actions;

export const selectUserVendorIds = (state: RootState) => state.searchRFXRequest.userVendorIds;

export const selectIsModalVisible = (state: RootState) =>
  state.searchRFXRequest.isModalVisible;

export const selectRequestIds = (state: RootState) =>
  state.searchRFXRequest.requestIds;

export default searchRFXRequestSlice.reducer;
